import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {round} from '../../../../utils/func';
import ImgBlock from './Image';

const Block = (props) => {
  const {
    tour,
    guide,
    tourDate,
    timeSlotId,
    persons,
    price,
  } = props;

  const getTime = () => {
    if (tour && tour.tourDates && tour.tourDates[0])
      for (let i = 0; i < tour.tourDates.length; i++) {
        if (tour.tourDates[i].id === timeSlotId) {
          return moment(tour.tourDates[i].startTime, "HH:mm").locale('en').format('hh:mm A')
        }
      }
    return '';
  };

  return (
    <li className="booking__item">
      <div className="booking__item-body booking__details-body">
        <div className="booking__item-block  booking__details-img">
          <figure className="booking__item-header">
            <ImgBlock
              images={tour.tourPhotos}
            />
            <figcaption className="booking__item-info">
              <p className="booking__item-title">{tour.title}</p>
              {guide && <p className="booking__item-status">Staff included</p>}
            </figcaption>
          </figure>
        </div>
        <div className="booking__item-block booking__date">
          <p className="booking__item-group">
            <span className="booking__label">Date </span>
            <span className="booking__content">{moment(tourDate).locale('en').format('YYYY MMMM DD')}</span>
          </p>
          <p className="booking__item-group">
            <span className="booking__label">Time </span>
            <span className="booking__content">{getTime()}</span>
          </p>
          <p className="booking__item-group">
            <span className="booking__label">Number of attendees </span>
            <span className="booking__content">{persons}</span>
          </p>
        </div>
        <div className="booking__item-block booking__price">
          <p className="booking__item-group">
            <span className="booking__label">Price/person</span>
            <span className="booking__content"><span>$</span> {round(price / persons)}</span>
          </p>
        </div>
      </div>
      <div className="booking__item-footer">
        <p className="booking__item-group">
          <span className="booking__label">Price</span>
          <span className="booking__content"><span>$</span>{round(price)}</span>
        </p>
      </div>
    </li>
  )
};

Block.propTypes = {
  tour: PropTypes.object,
  guide: PropTypes.bool,
  tourDate: PropTypes.string,
  persons: PropTypes.number,
  price: PropTypes.number,
  timeSlotId: PropTypes.number,
};

export default Block;


// WEBPACK FOOTER //
// ./src/app/containers/UserOrders/OrderDetails/Block/index.js